var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_7735",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_7735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2403 18.3653C15.9391 18.3653 16.5304 18.1233 17.0144 17.6394C17.4983 17.1554 17.7403 16.5641 17.7403 15.8653V8.70188H21.1537V6.77875H16.7787V14.0384C16.5721 13.8141 16.3405 13.6458 16.0841 13.5338C15.8276 13.4215 15.5464 13.3653 15.2403 13.3653C14.5416 13.3653 13.9502 13.6073 13.4663 14.0913C12.9823 14.5752 12.7403 15.1666 12.7403 15.8653C12.7403 16.5641 12.9823 17.1554 13.4663 17.6394C13.9502 18.1233 14.5416 18.3653 15.2403 18.3653ZM10.1444 21.25C9.56896 21.25 9.08854 21.0573 8.70312 20.6719C8.31771 20.2865 8.125 19.806 8.125 19.2306V5.76937C8.125 5.19396 8.31771 4.71354 8.70312 4.32812C9.08854 3.94271 9.56896 3.75 10.1444 3.75H23.6056C24.181 3.75 24.6615 3.94271 25.0469 4.32812C25.4323 4.71354 25.625 5.19396 25.625 5.76937V19.2306C25.625 19.806 25.4323 20.2865 25.0469 20.6719C24.6615 21.0573 24.181 21.25 23.6056 21.25H10.1444ZM10.1444 20H23.6056C23.7981 20 23.9745 19.9199 24.1347 19.7597C24.2949 19.5995 24.375 19.4231 24.375 19.2306V5.76937C24.375 5.57687 24.2949 5.40052 24.1347 5.24031C23.9745 5.0801 23.7981 5 23.6056 5H10.1444C9.95187 5 9.77552 5.0801 9.61531 5.24031C9.4551 5.40052 9.375 5.57687 9.375 5.76937V19.2306C9.375 19.4231 9.4551 19.5995 9.61531 19.7597C9.77552 19.9199 9.95187 20 10.1444 20ZM6.39437 25C5.81896 25 5.33854 24.8073 4.95312 24.4219C4.56771 24.0365 4.375 23.5561 4.375 22.9809V8.26937H5.625V22.9809C5.625 23.1732 5.7051 23.3495 5.86531 23.5097C6.02552 23.6699 6.20187 23.75 6.39437 23.75H21.1056V25H6.39437Z",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryMusic);
export default __webpack_public_path__ + "static/media/library_music.2f21524a0583b9be0e78455f9062fcc5.svg";
export { ForwardRef as ReactComponent };